import { useEffect, useState } from 'react';
import { anrufZustand } from '../lib/anrufzeit.js';

const LEVEL_DOT = {
  gruen: 'bg-emerald-500',
  gelb: 'bg-amber-400',
  rot: 'bg-red-500',
  grau: 'bg-slate-300',
};

const LEVEL_FALLBACK_TEXT = {
  gruen: 'Jetzt erreichbar',
  gelb: 'Bald erreichbar',
  rot: 'Nicht erreichbar',
  grau: 'Keine Anrufzeiten',
};

/**
 * Ampel-Anzeige für die Anrufzeiten einer Praxis.
 *
 * Aktualisiert sich jede Minute selbst, damit der Status (z. B. von „Öffnet
 * um 08:00“ → „Jetzt erreichbar“) ohne Reload kippt.
 *
 * Props:
 *   praxis    Praxis-Record (oder vergleichbares Objekt mit anruf_*-Feldern).
 *   showText  true → Punkt + erklärender Text. false → nur Punkt mit Tooltip.
 *   size      'sm' | 'md' — Größe des Punkts.
 */
export default function AnrufAmpel({ praxis, showText = false, size = 'md' }) {
  // Tick erzwingt Re-Render; der Wert selbst wird nicht ausgelesen.
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 60_000);
    return () => clearInterval(id);
  }, []);

  const { level, text } = anrufZustand(praxis);
  const titel = text || LEVEL_FALLBACK_TEXT[level];
  const dotSize = size === 'sm' ? 'h-2.5 w-2.5' : 'h-3 w-3';
  const dotClass = `inline-block rounded-full ring-1 ring-inset ring-black/10 ${LEVEL_DOT[level]} ${dotSize}`;

  if (!showText) {
    return <span className={dotClass} title={titel} aria-label={titel} />;
  }

  return (
    <span className="inline-flex items-center gap-2 text-sm">
      <span className={dotClass} aria-hidden="true" />
      <span className="text-slate-700">{titel}</span>
    </span>
  );
}
